import {
  IPostRequiredActionDismissParams,
  IShiftRequiredAction,
} from '@network/models/gig-schedule.model'
import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'

export class RequiredActionsApi {
  constructor(private axios: AxiosService) {}

  getRequiredActions = async () => {
    const response = await this.axios.get<IPayload<IShiftRequiredAction[]>>(
      Endpoints.getRequiredActions,
    )
    return response
  }

  postRequiredActionDismiss = async (
    params: IPostRequiredActionDismissParams,
  ) => {
    const response = await this.axios.post<IPayload<{}>>(
      Endpoints.postRequiredActionDismiss,
      params,
    )
    return response
  }
}
